function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemovestockicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166.345,
    height: 120,
    viewBox: "0 0 166.345 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cdiw0lop4a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 664",
    transform: "translate(0 -.315)",
    style: {
      fill: "#fff",
      stroke: "#707070"
    },
    d: "M0 0h166.345v120H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2iv4vi240b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9154",
    transform: "translate(-.469)",
    style: {
      fill: "none"
    },
    d: "M0 0h132v132H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17",
    transform: "translate(0 .314)",
    style: {
      clipPath: "url(#cdiw0lop4a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10511",
    transform: "translate(17.469 -6.314)",
    style: {
      clipPath: "url(#2iv4vi240b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46491",
    d: "M.026 19.092C.026 13.08.049 7.067 0 1.055-.008.172.174 0 1.054 0q61.587.042 123.173.024c2.357 0 4.715.023 7.071-.017.554-.009.758.107.648.662a2.7 2.7 0 0 0 0 .514q0 64.8.024 129.608c0 .966-.217 1.184-1.181 1.184q-64.8-.042-129.6 0c-.964 0-1.185-.217-1.182-1.184C.038 118.3.026 105.8.026 93.3c.52-.036.744.379 1 .7a3.841 3.841 0 0 0 3.15 1.452c.6.009 1.2.01 1.8.01h67.676a11.607 11.607 0 0 1 2.3.1c.783.2.989.892 1.217 1.52a28.39 28.39 0 0 0 11.52 13.946 27.5 27.5 0 0 0 16.825 4.054A28.2 28.2 0 0 0 123.662 67.6a5.142 5.142 0 0 0-1.542-1.339 26.159 26.159 0 0 0-8.014-5.165c-.561-.241-1.088-.512-1.242-1.185a11.314 11.314 0 0 1-.1-2.182V22.107c0-.557.016-1.115-.021-1.671a3.368 3.368 0 0 0-3.618-3.5c-2.438-.051-4.877.029-7.315-.035q-10.376.087-20.751 0c-.813.058-1.628.031-2.442.031q-36.317 0-72.634-.017c-2.126 0-4.137.047-5.485 2.038a.481.481 0 0 1-.472.142",
    transform: "translate(-.168 -.444)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46492",
    d: "M.076 50.577c1.04-2.048 2.732-2.61 4.962-2.6q37.19.08 74.381.035c.556 0 1.112.025 1.668.038a2.225 2.225 0 0 1 .4 1.7q.016 24.7.006 49.4c0 .43-.052.855-.078 1.281a3.624 3.624 0 0 1-.809 1.716 28.889 28.889 0 0 0-4.943 12.391c-.092.639-.037 1.415-.823 1.762a7.025 7.025 0 0 1-2.044.148q-35.189.005-70.378 0a3.334 3.334 0 0 1-2.346-.415z",
    transform: "translate(-.218 -31.929)",
    style: {
      fill: "#fedf7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46493",
    d: "M.076 245.976h75.051a1.262 1.262 0 0 1 .375 1.173 26.785 26.785 0 0 0 .938 8.9 1.521 1.521 0 0 1-.023 1.249q-35.688 0-71.374.025c-2.214 0-3.915-.555-4.967-2.586z",
    transform: "translate(-.218 -161.88)",
    style: {
      fill: "#fecf64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46494",
    d: "M219.616 207.189a30.366 30.366 0 0 1-1.29-11.324 29.947 29.947 0 0 1 5.957-15.192 15.192 15.192 0 0 1 5.1-5.319 27.435 27.435 0 0 1 15.851-5.63 25.106 25.106 0 0 1 10.468 1.37 1.754 1.754 0 0 1 .7.55 32.192 32.192 0 0 1 7.858 4.483 4.114 4.114 0 0 1 1.147 1.168 18.616 18.616 0 0 1 4.192 7.3 28.783 28.783 0 0 1-11.9 34.253 28.161 28.161 0 0 1-16.412 4.211 28.944 28.944 0 0 1-13.732-4.165c-.669-.4-1.2-.958-1.86-1.36a27.354 27.354 0 0 1-6.079-10.342",
    transform: "translate(-143.417 -111.771)",
    style: {
      fill: "#dd6f53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46495",
    d: "M256.6 90.321a28.1 28.1 0 0 0-19.54 9.231c-.436.465-.854.946-1.281 1.419V48.186h20.826a2.213 2.213 0 0 1 .406 1.7q.016 19.367 0 38.734a2.152 2.152 0 0 1-.413 1.7",
    transform: "translate(-154.914 -32.069)",
    style: {
      fill: "#fecf64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46496",
    d: "M296.36 90.24q0-21.067.008-42.135c2.656-.014 5.312-.066 7.967-.029a3.617 3.617 0 0 1 3.323 3.34c.032.341.011.687.011 1.03l-.011 39.414a34.943 34.943 0 0 0-9.4-1.75 12.725 12.725 0 0 0-1.9.129",
    transform: "translate(-194.673 -31.989)",
    style: {
      fill: "#fec150"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46497",
    d: "M239.886 232.176c.629-.06 1.009.421 1.467.706a28.307 28.307 0 0 0 14.1 4.46 27.623 27.623 0 0 0 22.049-8.924 27.208 27.208 0 0 0 7.282-15.131 28.157 28.157 0 0 0-2.892-17.493c-.688-1.326-1.528-2.573-2.3-3.856a14.724 14.724 0 0 1 4.186 4.425c12.193 16.788 2.643 40.809-17.752 44.561-9.732 1.791-18.17-.969-25.323-7.768a10.93 10.93 0 0 1-.822-.98",
    transform: "translate(-157.608 -126.416)",
    style: {
      fill: "#c35e45"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46498",
    d: "M32.319 138.537q-.018-14.982-.034-29.965c0-3-.013-6 .005-9 .009-1.4.558-1.982 1.928-1.983 6.289 0 12.577.015 18.866.027A2.73 2.73 0 0 1 53.258 99q-.009 18.021 0 36.041c0 .515 0 1.03-.033 1.544a2.148 2.148 0 0 1-1.76 2.1 9.131 9.131 0 0 1-2.29.272q-7.515.005-15.029-.005a2.359 2.359 0 0 1-1.825-.41",
    transform: "translate(-21.353 -64.491)",
    style: {
      fill: "#f3fafe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46499",
    d: "M146.617 71.263a4.023 4.023 0 0 1 3.106 1.35c2.4 2.391 4.8 4.781 7.181 7.2a3.8 3.8 0 0 1-.015 5.886q-8.813 8.84-17.636 17.672c-1.811 1.813-3.809 1.82-5.607.025q-3.735-3.727-7.455-7.47c-1.873-1.885-1.881-3.872-.014-5.746q8.766-8.8 17.54-17.586a3.628 3.628 0 0 1 2.9-1.328",
    transform: "translate(-82.063 -47.209)",
    style: {
      fill: "#fec150"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46500",
    d: "M32.3 138.5h16.941a4.819 4.819 0 0 0 1.024-.018c1.951-.434 2.591-.181 2.581-2.893-.047-12.129-.021-24.258-.019-36.387a2.777 2.777 0 0 1 .241-1.625c3.587-.191 3.84.046 3.84 3.582v38.378c0 2.292-.507 2.8-2.775 2.805H35.37c-2.8 0-3.155-.36-3.111-3.2 0-.214.029-.428.044-.641",
    transform: "translate(-21.337 -64.452)",
    style: {
      fill: "#e3f5fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46501",
    d: "M261.8 193.623a21.536 21.536 0 0 1 10.169 2.852c.835.49.846.807.173 1.479q-13.332 13.3-26.6 26.667c-.856.864-1.167.56-1.624-.285a20.246 20.246 0 0 1-1.029-18.3 20.484 20.484 0 0 1 18.911-12.413",
    transform: "translate(-158.458 -127.522)",
    style: {
      fill: "#f3fafe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46502",
    d: "M295.2 222.02c.165-.195.343-.38.494-.586.576-.785.922-.527 1.355.188 7.448 12.294-.438 28.774-14.648 30.653a20.549 20.549 0 0 1-12.77-2.3c-1.643-.884-1.647-.875-.186-2.146a3.772 3.772 0 0 1 1.873-.325 22.681 22.681 0 0 0 15.352-5.869 23.1 23.1 0 0 0 8.205-17.864 3.582 3.582 0 0 1 .325-1.748",
    transform: "translate(-176.303 -145.459)",
    style: {
      fill: "#e3f5fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46503",
    d: "M297.245 224.057a23.59 23.59 0 0 1-5.15 16.594 24 24 0 0 1-15.249 9 32.091 32.091 0 0 1-5.356.214q7.369-7.428 14.742-14.853c3.656-3.666 7.341-7.3 11.013-10.954",
    transform: "translate(-178.35 -147.496)",
    style: {
      fill: "#f3fafe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46504",
    d: "M55.622 173.332c1.542 0 3.085-.02 4.627.005a2.083 2.083 0 0 1 2.284 1.943 2.041 2.041 0 0 1-2.181 2.045q-4.755.06-9.51 0a1.971 1.971 0 0 1-2.134-2.07 1.993 1.993 0 0 1 2.159-1.912c1.584-.036 3.17-.009 4.755-.009",
    transform: "translate(-32.134 -114.198)",
    style: {
      fill: "#2c4d66"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46505",
    d: "M55.655 196.718c1.457 0 2.913-.014 4.37 0 1.548.019 2.5.781 2.511 1.982s-.947 2.015-2.466 2.021q-4.5.018-9 0c-1.481-.008-2.345-.756-2.361-1.973s.847-1.993 2.316-2.025c1.541-.033 3.084-.008 4.627-.008",
    transform: "translate(-32.139 -129.547)",
    style: {
      fill: "#2c4d66"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46506",
    d: "M55.569 121.692c-1.5 0-3 .017-4.5 0s-2.349-.749-2.36-1.955.864-1.984 2.323-1.991q4.625-.021 9.25 0a1.986 1.986 0 1 1 .037 3.94c-1.584.033-3.169.008-4.754.008",
    transform: "translate(-32.139 -77.713)",
    style: {
      fill: "#2b4d66"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46507",
    d: "M55.588 158.3c-1.542 0-3.084.014-4.625 0-1.374-.016-2.23-.764-2.253-1.925a1.953 1.953 0 0 1 2.176-1.993q4.753-.03 9.507 0a1.97 1.97 0 0 1 2.142 1.913 2 2 0 0 1-2.193 2c-1.584.024-3.169.005-4.753.006",
    transform: "translate(-32.137 -101.752)",
    style: {
      fill: "#2b4d66"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46508",
    d: "M162.425 91.092c-.157.178-.341.411-.55.62q-8.167 8.19-16.328 16.387c-.574.579-.928.661-1.537.028q-2.984-3.1-6.08-6.1c-.6-.585-.609-.942-.006-1.542q8.2-8.155 16.352-16.362c.4-.4.719-.853 1.343-.214 2.124 2.177 4.288 4.314 6.434 6.47.176.177.4.335.37.71",
    transform: "translate(-90.395 -55.307)",
    style: {
      fill: "#fedf7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46509",
    d: "M169.166 107.992c.054.363-.233.72-.578 1.064-1.815 1.812-3.613 3.64-5.44 5.44a1.917 1.917 0 1 1-2.7-2.711q2.649-2.7 5.344-5.354a1.789 1.789 0 0 1 2.21-.454 2.083 2.083 0 0 1 1.16 2.015",
    transform: "translate(-105.005 -69.862)",
    style: {
      fill: "#fec150"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovestockicon);
export default __webpack_public_path__ + "static/media/removestockicon.e4f13e8742061ee26d26ac88d264c386.svg";
export { ForwardRef as ReactComponent };